import { useLocation, Navigate } from 'react-router-dom';

/**
 * Component that immediately redirects to login with current path preserved
 * This ensures consistent behavior with other authentication guards
 */
export function CommunityAuthRequired() {
  const location = useLocation();

  // Immediately redirect to login with current path preserved
  return <Navigate replace to={`/login?redirectTo=${encodeURIComponent(location.pathname + location.search)}`} />;
}
